import {SurveyId, SurveyValues} from 'common/models/survey';
import {Control, useWatch} from 'react-hook-form';
import {useDebounce, useLocalStorage} from 'react-use';

const usePersistForm = (
    surveyId: SurveyId,
    control: Control,
    enabled: boolean,
): [SurveyValues | undefined, () => void] => {
    const [localStorageValues, setLocalStorageValues, removeLocalStorageValues] =
        useLocalStorage<SurveyValues>(`survey-${surveyId}`);

    const data = useWatch({control});

    useDebounce(
        () => {
            if (enabled) {
                //not save captcha value to local storage
                delete data.captcha;
                setLocalStorageValues(data);
            }
        },
        300,
        [data, enabled],
    );

    return [localStorageValues, removeLocalStorageValues];
};
export default usePersistForm;
